import React from 'react';
import styled from 'styled-components';
import * as FormUI from '../../pageForm/FormUI';
import { theme } from '../../../styles/theme';

interface IScheduleAlertState {
  isActive: boolean;
}

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const Indicator = styled.span<{ $isActive: boolean }>`
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 6px;
  border-radius: 50%;
  background-color: ${({ $isActive }) =>
    $isActive ? theme.colors.mainBlue : 'currentColor'};
`;

export default ({ isActive }: IScheduleAlertState) => (
  <Container>
    <Indicator $isActive={isActive} />
    <FormUI.DataLabel>{isActive ? 'On' : 'Off'}</FormUI.DataLabel>
  </Container>
);
